import React from 'react';
import { connect } from 'react-redux';
import { findWithUUID } from '@/utils/uuidHelper';
import NoRows from '@/components/table/NoRows';
import DictionaryLookupEditor from './DictionaryLookupEditor';
import DictionaryLookupsInformation from './DictionaryLookupsInformation';
import { canEditDataset } from '../../helper';

const DictionaryLookupContent = ({ hasLookups, showEditor }) => (
  <>
    {showEditor && (<DictionaryLookupEditor />)}
    {!showEditor && (<DictionaryLookupsInformation />)}
    {!hasLookups && !showEditor && (
    <NoRows
      icon="list alternate outline"
      entity="lookup"
      className="aridhia-no-lookup"
    />
    )}
  </>
);

const mapStateToProps = ({
  datasets: {
    lookups,
  },
  auth: {
    role,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const items = dictionary ? dictionary.lookups || {} : {};
  const hasLookups = Object.keys(items).length > 0;

  return (
    {
      hasLookups,
      showEditor: lookups.lookupBeingEdited.isEditing || (canEditDataset(lookups, role) && !hasLookups),
    }
  );
};

export default connect(mapStateToProps)(DictionaryLookupContent);
